import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'morva-export-warning-modal',
  templateUrl: './export-warning-modal.component.html',
  styleUrl: './export-warning-modal.component.scss'
})
export class ExportWarningModalComponent {
  @Input() messageOne: string = '';
  @Input() messageTwo: string = '';

  constructor(
    private dialogRef: NbDialogRef<ExportWarningModalComponent>
  ) {}
  
  ngOnInit(): void {}


  close() {
    this.dialogRef.close('cancel');
  }
  
  continue() {
    this.dialogRef.close('continue');
  }
}


